import type { AuthorizedResource } from '@/services/bff/permission.api';

export type AuthorizedResourceAccessMap = Record<string, boolean>;

export const isAuthorizedResourceAllowed = (effect?: string | null) =>
  effect === 'ALLOW';

export function buildAuthorizedResourceAccessMap(
  authorizedResources: AuthorizedResource[] = [],
): AuthorizedResourceAccessMap {
  const allowedKeys = new Set<string>();
  const deniedKeys = new Set<string>();
  const deniedResources = new Set<string>();

  authorizedResources.forEach((resource) => {
    if (!resource?.code) {
      return;
    }

    const target = isAuthorizedResourceAllowed(resource.effect)
      ? allowedKeys
      : deniedKeys;
    target.add(resource.code);

    if (!isAuthorizedResourceAllowed(resource.effect)) {
      deniedResources.add(resource.code);
    }

    (resource.actions ?? []).forEach((action) => {
      if (action) {
        target.add(`${resource.code}:${action}`);
      }
    });
  });

  const accessMap: AuthorizedResourceAccessMap = {};

  allowedKeys.forEach((key) => {
    const resourceCode = key.split(':')[0];
    accessMap[key] = !deniedKeys.has(key) && !deniedResources.has(resourceCode);
  });

  deniedKeys.forEach((key) => {
    accessMap[key] = false;
  });

  deniedResources.forEach((resourceCode) => {
    accessMap[resourceCode] = false;
  });

  return accessMap;
}
